export const LogoMark = ({ className = "h-11 w-11", light = false }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <circle cx="50" cy="50" r="46" fill="none" stroke="#7ab51d" strokeWidth="3" />
    {[28, 40, 52, 64, 76].map((x, i) => {
      const tall = i % 2 === 1;
      const top = tall ? 22 : 30;
      return (
        <g key={x}>
          <line x1={x} y1={top + 8} x2={x} y2="80" stroke="#7ab51d" strokeWidth="1.6" />
          <ellipse cx={x} cy={top} rx={tall ? 3.6 : 5} ry={tall ? 5.4 : 8} fill={light ? "#c8e39a" : "#4b5a1e"} />
        </g>
      );
    })}
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark light={light} />
    <span className={`leading-[0.95] text-[15px] tracking-tight lowercase ${light ? "text-[#f3efe4]" : "text-[#1a382b]"}`}>
      quinta
      <br />
      dos pinhais
    </span>
  </span>
);
